import $ from 'jquery';
import { Formatter } from '@dealersites/dealersite-js-core';
import { runPayments } from '@oem-theme/components/payment-calc/dsp-calculator';
import { listDOMItem } from './showroom-utilities';

// seperate base and total properties - [cash, lease, finance] because the non-targeted incentives comprising this amount can differ
class Configuration {
  constructor({
    id,
    base,
    baseFinance,
    baseLease,
    costs,
    taxes,
    fees,
    DOM,
    total,
    options,
    next,
    refNum,
    financeTotal,
    leaseTotal,
  } = initial) {
    (this.id = id), (this.base = base);
    this.baseFinance = baseFinance;
    this.baseLease = baseLease;
    this.costs = costs;
    this.taxes = taxes;
    this.fees = fees;
    // DOM (for output): { base, costs, total, fees, taxes, options, next }
    this.DOM = DOM;
    this.total = total;
    // options (cost added) { msrp, primary_name }
    this.options = options;
    this.next = next;
    this.refNum = refNum;
    this.financeTotal = financeTotal;
    this.leaseTotal = leaseTotal;

    this.updatePayments();
  }

  updatePayments() {
    runPayments(this.total, 2, this.financeTotal, this.leaseTotal);
    return this;
  }

  updateTotal() {
    this.total = this.base + this.costs;
    this.financeTotal = this.baseFinance + this.costs;
    this.leaseTotal = this.baseLease + this.costs;

    this.updatePayments();

    return this;
  }

  updateCosts(newCosts) {
    this.costs = newCosts;
    return this;
  }

  updateFees(newFees) {
    this.fees = newFees;
    return this;
  }

  updateTaxes(newTaxes) {
    this.taxes = newTaxes;
    return this;
  }

  updateOptions(newOptions) {
    this.options = newOptions;
    return this;
  }

  updateNext(newNext) {
    this.next = newNext;
    this.updateDOMNext();
    return this;
  }

  updateDOMNext() {
    this.DOM.next.attr('href', this.next);
    return this;
  }

  updateDOM() {
    const CONFIG = this;
    for (const [key, value] of Object.entries(CONFIG.DOM)) {
      if (key != 'options' && key != 'next') {
        CONFIG.DOM[key].each(function () {
          $(this).text(Formatter.price(CONFIG[key], 2));
        });
      }
    }

    this.updateDOMOptions();

    return this;
  }

  updateDOMOptions() {
    if (!$.isEmptyObject(this.options)) {
      this.options.forEach((opt) => {
        this.DOM.options.append(listDOMItem(opt));
      });
    }
    return this;
  }

  print() {
    for (const [key, value] of Object.entries(this)) {
      if (key != 'options' && key != 'DOM') {
        console.log(`${key} : ${value}`);
      }
    }
    console.log(this.DOM);
    console.log(this.options);
  }
}

export default Configuration;
